const CSR_TIMER_CACHE_KEY = 'pomelo_care_time'

const timeLabelData = Object.freeze({
  day: {
    key: 'POMELO_CARE_GIRLS_HOME_TEAM_DAYS',
    value: 'days',
  },
  hour: {
    key: 'POMELO_CARE_GIRLS_HOME_TEAM_HOURS',
    value: 'hours',
  },
  minute: {
    key: 'POMELO_CARE_GIRLS_HOME_TEAM_MINUTES',
    value: 'minutes',
  },
  second: {
    key: 'POMELO_CARE_GIRLS_HOME_TEAM_SECONDS',
    value: 'seconds',
  },
})

export { CSR_TIMER_CACHE_KEY, timeLabelData }
